import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatChipsModule } from '@angular/material/chips';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Subject, takeUntil } from 'rxjs';
import { KsefMonitoringApiService } from 'shared/services/api/ksef-monitoring.api.service';

interface PendingBatch {
  userId: string;
  userEmail: string;
  companyName: string;
  invoicesCount: number;
  oldestPending: Date;
  newestPending: Date;
  waitingTime: string;
  alertLevel: 'normal' | 'warning' | 'critical';
  documentNumbers: string[];
}

@Component({
  selector: 'app-pending-batches',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatChipsModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './pending-batches.component.html',
  styleUrls: ['./pending-batches.component.scss']
})
export class PendingBatchesComponent implements OnInit, OnDestroy {
  
  displayedColumns: string[] = ['userEmail', 'companyName', 'invoicesCount', 'waitingTime', 'oldestPending', 'actions'];
  dataSource = new MatTableDataSource<PendingBatch>([]);
  
  isLoading = true;
  totalPendingInvoices = 0;
  totalUsers = 0;
  
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(
    private _ksefApiService: KsefMonitoringApiService
  ) {}

  ngOnInit(): void {
    this.loadPendingBatches();
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  loadPendingBatches() {
    this.isLoading = true;
    
    this._ksefApiService.getPendingBatches()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe({
        next: (response) => {
          const batches = response.data.batches || [];
          
          this.dataSource.data = batches.map((batch: any) => ({
            ...batch,
            oldestPending: new Date(batch.oldestPending),
            newestPending: new Date(batch.newestPending)
          }));
          
          this.totalPendingInvoices = response.data.totalPendingInvoices || 0;
          this.totalUsers = response.data.totalUsers || 0;
          this.isLoading = false;
        },
        error: (error) => {
          console.error('Błąd podczas ładowania pending batches:', error);
          this.isLoading = false;
        }
      });
  }

  refresh() {
    this.loadPendingBatches();
  }

  getAlertColor(level: string): string {
    const colors: Record<string, string> = {
      'normal': '',
      'warning': 'accent',
      'critical': 'warn'
    };
    return colors[level] || '';
  }

  getAlertIcon(level: string): string {
    const icons: Record<string, string> = {
      'normal': 'tabler_outline:clock',
      'warning': 'tabler_outline:alert-triangle',
      'critical': 'tabler_outline:alert-circle'
    };
    return icons[level] || 'tabler_outline:clock';
  }
}

